import { render, staticRenderFns } from "./InstitutionLogsView.vue?vue&type=template&id=361e9ac9&scoped=true"
import script from "./InstitutionLogsView.vue?vue&type=script&lang=js"
export * from "./InstitutionLogsView.vue?vue&type=script&lang=js"
import style0 from "./InstitutionLogsView.vue?vue&type=style&index=0&id=361e9ac9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361e9ac9",
  null
  
)

export default component.exports